function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "assets/styles/app.scss";
import "./dealers"; // Turned of because of the many requests
import Swiper, { Autoplay, Navigation, Pagination, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import "./ajaxLoadMore";
import "./languagePicker";
import "./downloadSwatch";
import "./swatchFilter";
import "./favorites";
import "./swatchRequest.js";
import "./blogFilter";
import "./video";
import "./shippingAddress.js";
import "./mobile-menu.js";
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import axios from "axios";
import "./equalHeight";
import "./sliderMobile";
import "./panel";
import AOS from "aos";
$(document).ready(() => {
  AOS.init({
    offset: '100px',
    // offset (in px) from the original trigger point
    once: true
  });
});
const loadedComponents = [];
document.addEventListener("DOMContentLoaded", /*#__PURE__*/_asyncToGenerator(function* () {
  /**
   * Bootstrap the components
   */
  for (const dataComponent of document.querySelectorAll("[data-component]")) {
    let componentName = dataComponent.dataset.component;
    if (loadedComponents.indexOf(componentName) === -1) {
      loadedComponents.push(componentName);
      try {
        let component = yield import( /* WebpackMode: "lazy" */
        /* webpackPrefetch: true */
        /* webpackPreload: true */
        `components/${componentName}/${componentName}.js`);
        console.log(`Component loaded: ${componentName}`);
        component.default();
      } catch (error) {
        console.error("Loading error: ", error);
      }
    }
  }
}));
$(document).ready(function () {
  // Replace this with another lightbox
  if ($(".video-play").length > 0) {}

  /* eslint-disable */
  const heroSwiper = new Swiper("#hero-slider", {
    fadeEffect: {
      crossFade: true
    },
    effect: "fade",
    autoplay: {
      disableOnInteraction: true,
      delay: 5000
    },
    pagination: {
      el: ".hero-slider__pagination",
      type: "bullets"
    },
    navigation: {
      nextEl: ".js-hero-next",
      prevEl: ".js-hero-prev"
    },
    on: {
      init: function () {
        const slide = this.slides[this.activeIndex];
        const content = slide.querySelector(".hero-slider__content");
        content.classList.add("hero-slider__content--is-active");
      },
      slideChange: function () {
        document.querySelectorAll('.hero-slider__content').forEach(content => {
          content.classList.remove('hero-slider__content--is-active');
        });
        const slide = this.slides[this.activeIndex];
        const content = slide.querySelector('.hero-slider__content');
        content.classList.add("hero-slider__content--is-active");
      }
    }
  });
  const worldsSwiper = new Swiper(".js-worlds-carousel", {
    modules: [Navigation, Pagination],
    direction: "horizontal",
    observer: true,
    observeParents: true,
    dots: true,
    slidesPerView: 2,
    spaceBetween: 32,
    navigation: {
      nextEl: ".js-worlds-next",
      prevEl: ".js-worlds-prev"
    }
  });
});
window.addEventListener("scroll", function () {
  const header = document.querySelector(".header");
  if (window.pageYOffset > 0) {
    header.classList.add("is-sticky");
  } else {
    header.classList.remove("is-sticky");
  }
});

/**
 * Accordion
 */
const items = document.querySelectorAll(".accordion button");
function toggleAccordion() {
  const itemToggle = this.getAttribute("aria-expanded");
  for (var i = 0; i < items.length; i++) {
    items[i].setAttribute("aria-expanded", "false");
  }
  if (itemToggle == "false") {
    this.setAttribute("aria-expanded", "true");
  }
}
items.forEach(item => item.addEventListener("click", toggleAccordion));

/**
 * Attribute tabs
 */
const $toggleBtn = $(".js-toggle-attribute");
const toggleTab = tabId => {
  $(".attribute-tabs__item").each((count, tab) => {
    const $id = $(tab).data("id");
    if ($id === tabId) {
      $(tab).addClass("attribute-tabs__item--is-active");
    } else {
      $(tab).removeClass("attribute-tabs__item--is-active");
    }
  });
  return tabId;
};
$toggleBtn.on("click", e => {
  const $this = $(e.currentTarget);
  const $id = $($this).data("id");
  $(".card-attribute").removeClass("is-active");
  $this.parent().addClass("is-active");
  toggleTab($id);
});
$(".js-mini-swatch").on("click", e => {
  const that = e.currentTarget;
  const id = $(that).data("id");
  const title = $(that).data("title");
  let params = new URLSearchParams();
  params.append("action", "render_swatch");
  params.append("id", id);
  axios.post("/wp-admin/admin-ajax.php", params).then(res => {
    $(".mini-swatch").removeClass("is-active");
    $(that).addClass("is-active");
    $(".js-preview-title").text(title);
    $(".swatch-preview__bg").css("background-image", "url(" + res.data.result + ")");
  });
});
Fancybox.bind($(".js-inspiration-more"), {
  animated: false,
  showClass: false,
  hideClass: false,
  click: false,
  dragToClose: false,
  Image: {
    zoom: false
  },
  Toolbar: {
    display: [{
      id: "counter",
      position: "center"
    }, "close"]
  }
});

/**
 * Trigger blog filters
 */
$(".js-trigger-filters").on("click", () => {
  $(".terms-nav").slideToggle();
});
$(".js-expand-color-filter").on("click", () => {
  $(".filter").addClass("is-active");
  $(".body").addClass("overflow");
});
$(".js-filter-close").on("click", () => {
  $(".filter").removeClass("is-active");
  $(".body").removeClass("overflow");
});
$('.js-close-search').on('click', e => {
  e.preventDefault();
  $('.header__searchbox').removeClass('header__searchbox--is-active');
});
$('.js-init-roomvo').on('click', e => {
  e.preventDefault();
  let product_type = 2; // replace with actual value
  let sku = $(e.currentTarget).data('sku');
  let url = `?roomvoStartVisualizer=true&product_type=${product_type}&sku=${sku}`;
  window.location.href = url;
});